import React from 'react';
import { Row, CardFooter } from 'reactstrap';
import * as QUESTION from '../../../constants/questions';
import { Button } from '../../../components/elements/buttons/Button';
import './PostCard.css';

export const PostCardFooter = ({
    question,
    onQuestionClick,
    onMultipleQuestionClick,
    showReviewForm,
}) => {
    return (
        <CardFooter>
            {question && question.type === QUESTION.YES_NO ? (
                <YESNO
                    questions={question.questions}
                    onClick={onQuestionClick}
                    showReviewForm={showReviewForm}
                />
            ) : question && question.type === QUESTION.MULTIPLE ? (
                <MULTIPLE onClick={onMultipleQuestionClick} showReviewForm={showReviewForm} />
            ) : question && question.type === QUESTION.OPEN ? (
                <OPEN
                    questions={question.questions}
                    onClick={onQuestionClick}
                    showReviewForm={showReviewForm}
                />
            ) : (
                <div />
            )}
        </CardFooter>
    );
};

const YESNO = ({ questions, onClick, showReviewForm }) => {
    return (
        <Row>
            {questions &&
                questions.length > 0 &&
                questions.map((question, index) => {
                    return showReviewForm ? (
                        <div />
                    ) : (
                        <Button
                            key={index}
                            title={question.title}
                            onClick={() => {
                                showReviewForm ? onClick(false) : onClick(question);
                            }}
                            classes="btn btn-outline-light"
                        />
                    );
                })}
        </Row>
    );
};

const MULTIPLE = ({ onClick, showReviewForm }) => {
    const multipleButton = [
        {
            title: 'Reason',
        },
    ];
    return (
        <Row>
            {multipleButton.map((question, index) => {
                return showReviewForm ? (
                    <div />
                ) : (
                    <Button
                        key={index}
                        title={question.title}
                        onClick={() => {
                            showReviewForm ? onClick(false) : onClick(question);
                        }}
                        classes="btn btn btn-outline-light"
                    />
                );
            })}
        </Row>
    );
};

const OPEN = ({ questions, onClick, showReviewForm }) => {
    return (
        <Row>
            {questions &&
                questions.length > 0 &&
                questions.map((question, index) => {
                    return showReviewForm ? (
                        <div />
                    ) : (
                        <Button
                            key={index}
                            title={question.title}
                            onClick={() => {
                                showReviewForm ? onClick(false) : onClick(question);
                            }}
                            classes="btn btn btn-outline-light"
                        />
                    );
                })}
        </Row>
    );
};
